import axios from "axios";
//规范为默认json格式，无需序列化。
import qs from "qs";
import store from '../store/index';
import router from '../router/index'
import { successAlert, messageAlert } from '../utils/alert'
import { Loading } from "element-ui";
import { baseURL } from '../utils/config'



if (process.env.NODE_ENV === 'development') {
    baseURL;
} else {
    baseURL;
}

let loadingInstance = null;
let loadingCount = 0;
//创建自定义axios对象
const instance = axios.create({
    baseURL,
    timeout: 30000,
})


// 增加请求拦截器
instance.interceptors.request.use(
    config => {
        console.group('本次请求的地址为:', config.url);
        if (config.url !== '/jfss/message/listnoreadmsg' &&
            config.url !== '/aircraftmonitoring/aircraftcompletemessage/getcuralarmdatas' &&
            config.url !== '/aircraftmonitoring/aircraftcompletemessage/flynum' &&
            config.url !== '/aircraftmonitoring/aircraftcompletemessage/latestaircraftcompletemessage'
        ) {
            addLoading();
        }


        // 给headers添加token属性
        if (store.state.token) {
            config.headers.token = store.state.token;
        }

        if (store.state.meteoToken) {
            config.headers.Authorization = store.state.meteoToken;
        }

        return config
    },
    error => {
        loadingCount = 0;
        if (loadingInstance) {
            loadingInstance.close();
        }
        return error;
    }
)

// 增加响应拦截器
instance.interceptors.response.use(
    res => {
        console.group('本次响应的地址为:', res.config.url);

        // 统一打印数据, 统一处理响应失败的数据
        if (res.data.code === 403) {
            // messageAlert('token过期，请重新登录')
            // location.href = 'http://119.3.231.246:9900/';
            router.push('/index/home');
        }
        if (res.data.code === 401) {
            // messageAlert('重新登录')
            // location.href = 'http://119.3.231.246:9900/';
            // router.push('/index/home');

        }
        if (res.config.url !== '/jfss/message/listnoreadmsg' &&
            res.config.url !== '/aircraftmonitoring/aircraftcompletemessage/getcuralarmdatas' &&
            res.config.url !== '/aircraftmonitoring/aircraftcompletemessage/flynum' &&
            res.config.url !== '/aircraftmonitoring/aircraftcompletemessage/latestaircraftcompletemessage'

        ) {
            closeLoading()
        }
        console.log(res);
        return res;
    },
    err => {
        loadingCount = 0;
        if (loadingInstance) {
            loadingInstance.close();
        }
        if (err.message.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
            messageAlert('请求超时，请重新再试')
        } else if (err.message.includes('Network Error')) {
            messageAlert('断网了')
        }
        return err;
    }
)

let addLoading = () => {
    loadingInstance = Loading.service({ fullscreen: true, background: 'rgba(0, 0, 0, 0.2)' });
    loadingCount++
}
let closeLoading = () => {
    loadingCount--
    if (loadingCount === 0) {
        if (loadingInstance) {
            loadingInstance.close();
        }
    }
}



//暴露get
export function get(url, params = null) {
    return new Promise((resolve, reject) => {
        instance.get(url, {
            params,
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err);
        });
    })
}

//暴露post  
export function post(url, params, isFile = false) {

    let data = params;

    //处理请求头
    let config = {
        Headers: { "Content-Type": "application/json" }
    }

    //处理文件
    if (isFile) {
        data = new FormData();
        for (let i in params) {
            data.append(i, params[i])
        }
        //处理有文件时请求头
        config = {
            Headers: {
                "Content-Type": "multiple/form-data"
            }
        }
        console.log(params);
    }

    return new Promise((resolve, reject) => {
        instance.post(url, data, config).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err)
        })
    })
}